/**
 * True only while the browser is hydrating markup a server rendered: the
 * shiftnews and quartz home routes for the groups the gate renders, and every
 * SDK page (/sdk/**). On a client rendered page this is false from the first
 * render and the guards that hold browser only work back stay inert. See
 * docs/SSR.md.
 */
export function isHydratingServerRender(): boolean {
  const nuxtApp = tryUseNuxtApp()
  return Boolean(nuxtApp?.isHydrating && nuxtApp.payload.serverRendered)
}

/**
 * True when the current render cannot touch the browser: the server itself, or
 * the hydration pass that has to reproduce what the server sent.
 */
export function isBeforeHydration(): boolean {
  return import.meta.server || isHydratingServerRender()
}
